import React, { PropsWithChildren } from "react";

type DropdownHeaderProps = PropsWithChildren<{}>;

const DropdownHeader = ({ children }: DropdownHeaderProps) => {
    return <div className="dropdown-header">{children}</div>;
};

export { DropdownHeader };
